// extracted by css-extract-rspack-plugin
export default {"container":"container-ossO8y","information":"information-t5qPqu","label":"label-T2j1tV text-base-medium","description":"description-PQ33ri text-base-light"};